import jwt_decode from "jwt-decode";
import { Container, Tabs, Tab, Nav, Modal, Button, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import chatico from '../../assets/chat-white.svg';
import { Link, useNavigate, useParams } from "react-router-dom";
import _ from 'lodash';
import jwtDecode from "jwt-decode";
import { Drawer, } from "antd";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
    MainContainer,
    ChatContainer,
    MessageList,
    Message,
    MessageInput,
} from "@chatscope/chat-ui-kit-react";
import { db } from "../../utils/firebase";
import { MessageIcon } from "../icons";


function ChatButton({ open, onDrawerClose, showDrawer, color, RefId, additionalClasses }) {
    if (RefId) {
        RefId = RefId.split(' ')[0];
        if (RefId.startsWith('S')) {
            RefId = RefId.slice(1)
        }
    }
    const userId = jwtDecode(localStorage.getItem("Token"))?._id
    const decodedJwt = jwtDecode(localStorage.getItem("Token"));
    // let {  } = useParams();
    // const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [unreadMessages, setUnreadMessages] = useState(0);
    const [messages, setMessages] = useState([]);
    const [isOpenedAnytime, setIsOpenedAnytime] = useState(false);
    const [fetchedCount, setFetchedCount] = useState(false);

    const onChange = (value) => {
        setMessage(value)
    }

    useEffect(() => {
        db.ref('/count/' + RefId).on('value', async (snapshot) => {
            setFetchedCount(true);
            let totalMessages = 0;
            const snapshotVal = await db.ref('/users/' + RefId + '/' + userId).get();
            if (snapshotVal.exists()) {
                const value = snapshotVal.val();
                totalMessages = value.count;
            }
            if (snapshot.exists()) {
                const value = snapshot.val();
                setUnreadMessages(value - totalMessages);
            }
        });

        db.ref('/users/' + RefId + '/' + userId).on('value', async (snapshot) => {
            setFetchedCount(true)
            let totalMessages = 0;
            const snapshotVal = await db.ref('/count/' + RefId).get();
            if (snapshotVal.exists()) {
                const value = snapshotVal.val();
                totalMessages = value;
            }
            if (snapshot.exists()) {
                const value = snapshot.val();
                setUnreadMessages(totalMessages - value.count);
            }
        });

        if (fetchedCount) {
            setUnreadMessages(0);
        }
    }, [])

    useEffect(() => {
        db.ref('/count/' + RefId).on('value', async (snapshot) => {
            setFetchedCount(true)
            let totalMessages = 0;
            const snapshotVal = await db.ref('/users/' + RefId + '/' + userId).get();
            if (snapshotVal.exists()) {
                const value = snapshotVal.val();
                totalMessages = value.count;
            }
            if (snapshot.exists()) {
                const value = snapshot.val();
                setUnreadMessages(value - totalMessages);
            }
        });

        db.ref('/users/' + RefId + '/' + userId).on('value', async (snapshot) => {
            let totalMessages = 0;
            setFetchedCount(true)
            const snapshotVal = await db.ref('/count/' + RefId).get();
            if (snapshotVal.exists()) {
                const value = snapshotVal.val();
                totalMessages = value;
            }
            if (snapshot.exists()) {
                const value = snapshot.val();
                setUnreadMessages(totalMessages - value.count);
            }
        });

        if (fetchedCount) {
            setUnreadMessages(0);
        }
    }, [RefId])


    return (
        <div
            className={`br-btn sq-btn linkBtn relative  px-3 rounded py-2 ${additionalClasses}`}
            onClick={showDrawer}
            style={{
                cursor: 'pointer'
            }}
        >
            <span style={{ color: color }} className="flex items-center justify-cen gap-x-2">
                <span className="ico relative">
                    {unreadMessages>0 && <span className=' h-4 aspect-square rounded-sm bg-red-500 absolute flex items-center justify-center text-[14px]  -top-0  right-[-3px]'>{unreadMessages}</span>}
                    <MessageIcon additionalClass={`text-white h-[18px] ${unreadMessages>0?"mt-2":"my-1"}  aspect-square `} />
                </span>
                <span className="mb-1">Chat</span>
            </span>
        </div>
    );
}

export default ChatButton;
